
import Content from "./Content";
import {RequestActionsConstant} from "./endpoint/RequestActionsConstant";
import Pagination from "./Pagination";

export enum ViewInfoViews {
    NEWSFEED = 1,
    NOTIICATION = 2,
    SEARCH = 3
}


export default class ViewInfo {
    public numItemToDisplay = 10;
    public lastPagePagination: Pagination = new Pagination();
    public itemsToDisplay: Content[] = [];
    public itemsPool: Content[] = [];
    public isPreloading = false;
    public searchText = "";
    constructor(public readonly viewId: ViewInfoViews, public readonly action: RequestActionsConstant) {
    }
}
